import Intro from "../components/Intro/Intro";


const Home = () => {
    return (
        <div>
            <Intro />
        </div>
    );
}

export default Home;